import React, { useState, useEffect } from "react";

import * as yup from "yup";

import { useForm, useFieldArray } from "react-hook-form";
import Error from "../../../components/forms/Error";
import DriverForm from "../../../components/forms/drivers/DriverForm";
import { useSelector, connect } from "react-redux";
import { useFirestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { updateDrivers } from "../../../store/actions/RestaurantActions";

import LoadingIndicator from "../../../components/common/LoadingIndicator";
import Alert from "../../../components/common/Alert";
import BackButton from "../../../components/common/BackButton";

const schema = yup.object().shape({
  drivers: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string(),
        name: yup
          .string()
          .required("Campo requerido")
          .min(6, "La contraseña debe ser de al menos 6 caracteres"),
        email: yup.string().email().required("Campo requerido"),
        password: yup
          .string()
          .min(6, "La contraseña debe ser de al menos 6 caracteres"),
      })
    )
    .min(1, "Debe haber al menos un driver en el restaurante.")
    .required("Debe haber al menos un driver en el restaurante."),
});

const DriverPage = ({ updateDrivers, success, error, loading }) => {
  const [restaurantId, setRestaurantId] = useState("");
  const [deletedDrivers, setDeletedDrivers] = useState([]);

  const { control, register, errors, handleSubmit, reset, getValues } = useForm(
    {
      validationSchema: schema,
    }
  );

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "drivers", // unique name for your Field Array
      // keyName: "id", default to "id", you can change the key name
    }
  );

  const uid = useSelector(({ firebase }) => firebase.auth.uid);

  useFirestoreConnect([
    { collection: "restaurants", where: [["user_id", "==", uid]] },
    {
      collection: "restaurants",
      doc: restaurantId || "nothing",
      subcollections: [{ collection: "drivers" }],
      storeAs: "drivers",
    },
  ]);

  const restaurant = useSelector(({ firestore }) =>
    firestore.ordered.restaurants ? firestore.ordered.restaurants[0] : {}
  );

  const drivers = useSelector(({ firestore }) => firestore.ordered.drivers);

  useEffect(() => {
    if (isLoaded(restaurant)) setRestaurantId(restaurant.id);
  }, [restaurant]);

  useEffect(() => {
    if (isLoaded(drivers) && !isEmpty(drivers)) reset({ drivers });
  }, [drivers]);

  if (!isLoaded(restaurant) || !isLoaded(drivers)) return <LoadingIndicator />;

  if (loading) return <LoadingIndicator />;

  return (
    <form
      className="px-16 py-8 text-gray-900 relative"
      onSubmit={handleSubmit((values) => {
        updateDrivers(restaurantId, values.drivers, deletedDrivers);
      })}
    >
      <BackButton />
      {success && (
        <Alert
          message="Se actualizaron los datos de los repartidores."
          secondary="Puedes realizar más cambios si deseas."
        ></Alert>
      )}
      {error && (
        <Alert
          message={error.message}
          secondary="Revisa bien los datos."
          danger
        ></Alert>
      )}
      <h2 className="font-bold text-lg mb-2 mt-4">Repartidores</h2>
      {fields && fields.length > 0
        ? fields.map((driver, index) => (
            <DriverForm
              key={driver.id}
              {...driver}
              driverIndex={index}
              register={register}
              errors={errors && errors.drivers ? errors.drivers[index] : {}}
              removeDriver={remove}
              deletedDrivers={deletedDrivers}
              setDeletedDrivers={setDeletedDrivers}
            />
          ))
        : null}
      <Error
        error={errors && errors.drivers ? errors.drivers : null}
        left
      ></Error>
      <div className="flex justify-between items-center">
        <button
          type="button"
          onClick={() => append({ name: "", email: "", password: "" })}
          className="bg-gray-300 rounded-md text-gray-700 py-2 px-4 text-sm font-bold border-2 border-gray-500"
        >
          Añadir repartidor
        </button>
        <button
          type="submit"
          className="block bg-brand-300 rounded-md text-brand-800 py-2 px-4 text-sm font-bold border-2 border-brand-700"
        >
          Subir datos
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  return { ...state.restaurant, ...state.restaurant.driverActions };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDrivers: (restaurantId, drivers, deletedDrivers) =>
      dispatch(updateDrivers(restaurantId, drivers, deletedDrivers)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverPage);
